const uuid = require("uuid");

/**
 * Gets a cookie.
 * @param {string} name - Cookie name to get.
 * @returns {string} Success or failure message of getting cookie.
 */
function getCookie(name) {
  try {
    const value = "; ".concat(document.cookie);
    const parts = value.split("; ".concat(name, "="));
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    } else {
      return "Cookie not found.";
    }
  } catch (err) {
    return err;
  }
}

/**
 * Sets a cookie with the key pair provided.
 * @param {string} name - Cookie name to be set.
 * @param {string} value - Cookie value to be set.
 * @returns {string} Success or failure message of cookie setting.
 */
function setCookie(name, value) {
  try {
    if (name === 'userId') {
      document.cookie = "".concat(name, "=").concat(value, ";max-age=31536000");
      return "Cookie ".concat(name, " set successfully.");
    } else {
      document.cookie = "".concat(name, "=").concat(value, ";max-age=1800");
      return "Cookie ".concat(name, " set successfully.");
    }
  } catch (err) {
    return err;
  }
}

/**
 * Get the current session ID for analytics use.
 * @returns {string} Returns session ID or error message.
 */
function getSessionId() {
  try {
    let sessionId = getCookie('sessionId');
    if (sessionId === "Cookie not found.") {
      sessionId = uuid.v4();
      setCookie('sessionId', sessionId);
    }
    return sessionId;
  } catch (err) {
    return err;
  }
}

/**
 * Get the current user ID for analytics use.
 * @returns {string} Returns session ID or error message.
 */
function getUserId() {
  try {
    let userId = getCookie("userId");
    if (userId === "Cookie not found.") {
      userId = uuid.v4().replace(/-/g, "");
      setCookie("userId", userId);
    }
    return userId;
  } catch (err) {
    return err;
  }
}

/**
 * Build on page metadata for later access.
 * @param {object} data - Object of data to build metadata for.
 * @returns {string} Success or failure message of data processing.
 */
function buildOnPageMetadata(data) {
  return new Promise(async (resolve, reject) => {
    try {
      if (typeof document !== "undefined") {
        for (let key in data) {
          let element = document.createElement('data');
          element.setAttribute('id', key);
          element.setAttribute('value', data[key]);
          document.body.appendChild(element);
        }
        resolve('On page metadata built successfully.');
      } else {
        reject('Document not found.');
      }
    } catch (err) {
      reject(err);
    }
  });
}

/**
 * Get all on page metadata for event use.
 * @param {object} data - Object of data to build metadata for.
 * @returns {string} Success or failure message of data processing.
 */
function getAllOnPageMetadata() {
  return new Promise(async (resolve, reject) => {
    try {
      let dataTags = document.querySelectorAll('data');
      let metadata = {};
      dataTags.forEach(tag => metadata[tag.id] = tag.value);
      if (metadata.length > 0) {
        resolve(metadata);
      } else {
        reject('No metadata found.');
      }
    } catch (err) {
      reject(err);
    }
  });
}

/**
 * Get page type from url.
 * @returns {string} Page type or failure message of data processing.
 */
function getPageTypeFromURL() {
  try {
    let url = new URL(window.location.href);
    let pathname = url.pathname;
    if (pathname === '/') return 'Home';
    let page = pathname.split('/')[1].replace(/-/g, ' ');
    let formattedPage = page.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
    return formattedPage;
  } catch (err) {
    return err;
  }
}

/**
 * Get department for click to call event
 * @returns {string} Department or failure message of data processing.
 */
function getClickToCallDepartment(anchor, number) {
  try {
    // Get department from data attribute
    if (anchor.dataset.department) {
      return anchor.dataset.department;
    }

    // Get hash list from local storage
    let hashListKey;
    for (let i = 0; i < localStorage.length; i++) {
      let currentKey = localStorage.key(i);
      if (currentKey.startsWith("hashList")) {
        hashListKey = currentKey;
      }
    }
    // Get department from hash list
    if (hashListKey) {
      let data = JSON.parse(localStorage.getItem(hashListKey));
      for (let item of data) {
        if (item.mainPhoneNumber && item.mainPhoneNumber.replace(/-/g, '').replace(/\s/g, '') === number) {
          return 'sales';
        }
        if (item.serviceDepartment && item.serviceDepartment.replace(/-/g, '').replace(/\s/g, '') === number) {
          return 'service';
        }
      }
    }

    // Default to sales
    return 'sales';
  } catch (err) {
    console.log(err);
    return 'sales';
  }
}
module.exports = {
  getCookie,
  setCookie,
  getSessionId,
  getUserId,
  buildOnPageMetadata,
  getAllOnPageMetadata,
  getPageTypeFromURL,
  getClickToCallDepartment
};